 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML9781137279101_01_PREXIV from '@/components/html/9781137279101_01_prexiv'
 import HTML9781137279101_02_CH01 from '@/components/html/9781137279101_02_ch01'
 import HTML9781137279101_03_CH02 from '@/components/html/9781137279101_03_ch02'
 import HTML9781137279101_04_CH03 from '@/components/html/9781137279101_04_ch03'
 import HTML9781137279101_05_CH04 from '@/components/html/9781137279101_05_ch04'
 import HTML9781137279101_06_CH05 from '@/components/html/9781137279101_06_ch05'
 import HTML9781137279101_07_CH06 from '@/components/html/9781137279101_07_ch06'
 import HTML9781137279101_08_CH07 from '@/components/html/9781137279101_08_ch07'
 import HTML9781137279101_09_CH08 from '@/components/html/9781137279101_09_ch08'
 import HTML9781137279101_10_CH09 from '@/components/html/9781137279101_10_ch09'
 import HTML9781137279101_11_CH10 from '@/components/html/9781137279101_11_ch10'
 import HTML9781137279101_12_CH11 from '@/components/html/9781137279101_12_ch11'
 import HTML9781137279101_13_CH12 from '@/components/html/9781137279101_13_ch12'
 import HTML9781137279101_14_CH13 from '@/components/html/9781137279101_14_ch13'
 import HTML9781137279101_15_CH14 from '@/components/html/9781137279101_15_ch14'
 import HTML9781137279101_16_CH15 from '@/components/html/9781137279101_16_ch15'
 import HTML9781137279101_17_CH16 from '@/components/html/9781137279101_17_ch16'
 import HTML9781137279101_18_CH17 from '@/components/html/9781137279101_18_ch17'
 import HTML9781137279101_19_CH18 from '@/components/html/9781137279101_19_ch18'
 import HTML9781137279101_20_REF01 from '@/components/html/9781137279101_20_ref01'
 import HTML9781137279101_21_REF02 from '@/components/html/9781137279101_21_ref02'
 import HTML9781137279101_22_NOT from '@/components/html/9781137279101_22_not'
 import HTML9781137279101_23_IND from '@/components/html/9781137279101_23_ind'
 import HTMLCOPY from '@/components/html/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/cover",
 			"name" : "html/cover",
 			"component" : HTMLCOVER
 		},
 		{
 			"path" : "/html/9781137279101_01_prexiv",
 			"name" : "html/9781137279101_01_prexiv",
 			"component" : HTML9781137279101_01_PREXIV
 		},
 		{
 			"path" : "/html/9781137279101_02_ch01",
 			"name" : "html/9781137279101_02_ch01",
 			"component" : HTML9781137279101_02_CH01
 		},
 		{
 			"path" : "/html/9781137279101_03_ch02",
 			"name" : "html/9781137279101_03_ch02",
 			"component" : HTML9781137279101_03_CH02
 		},
 		{
 			"path" : "/html/9781137279101_04_ch03",
 			"name" : "html/9781137279101_04_ch03",
 			"component" : HTML9781137279101_04_CH03
 		},
 		{
 			"path" : "/html/9781137279101_05_ch04",
 			"name" : "html/9781137279101_05_ch04",
 			"component" : HTML9781137279101_05_CH04
 		},
 		{
 			"path" : "/html/9781137279101_06_ch05",
 			"name" : "html/9781137279101_06_ch05",
 			"component" : HTML9781137279101_06_CH05
 		},
 		{
 			"path" : "/html/9781137279101_07_ch06",
 			"name" : "html/9781137279101_07_ch06",
 			"component" : HTML9781137279101_07_CH06
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js